import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { errMsg, fmtDate } from "@/lib/api";
import { useMember } from "@/pages/Member";
import { Card } from "@/components/member/MemberOverview";

const Ticket = ({ t, call, reload }) => {
  const [msg, setMsg] = useState("");
  const send = async () => {
    try {
      await call("post", `/mlm/me/tickets/${t.id}/reply`, { message: msg });
      setMsg("");
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="rounded-xl border border-slate-200 p-4 text-sm" data-testid={`ticket-${t.reference}`}>
      <p className="font-semibold">{t.subject} <span className="text-xs font-normal capitalize text-slate-500">· {t.reference} · {t.status}</span></p>
      {t.messages.map((m, i) => <p key={i} className={`mt-2 rounded-lg p-2 ${m.from === "support" ? "bg-amber-50" : "bg-slate-50"}`}><span className="text-xs font-semibold uppercase text-slate-500">{m.from === "support" ? "Support" : "You"} · {fmtDate(m.at, true)}</span><br />{m.text}</p>)}
      {t.status !== "closed" && <div className="mt-2 flex gap-2"><Input value={msg} onChange={(e) => setMsg(e.target.value)} placeholder="Reply" /><Button size="sm" disabled={!msg} onClick={send}>Send</Button></div>}
    </div>
  );
};

export const MemberInbox = () => {
  const [notes, , call] = useMember("/mlm/me/notifications");
  const [tickets, reload] = useMember("/mlm/me/tickets");
  const [f, setF] = useState({ subject: "", message: "" });
  useEffect(() => {
    call("post", "/mlm/me/notifications/read").catch(() => {});
  }, [call]);
  if (!notes || !tickets) return <p className="text-slate-500">Loading…</p>;
  const create = async () => {
    try {
      await call("post", "/mlm/me/tickets", f);
      toast.success("Ticket created");
      setF({ subject: "", message: "" });
      reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <Card title="Notifications" testid="member-notifications">
        {notes.length ? notes.map((n) => <div key={n.id} className="border-b border-slate-100 py-2 text-sm last:border-0"><p className="font-semibold">{n.title}</p><p className="text-slate-600">{n.body}</p><p className="text-xs text-slate-400">{fmtDate(n.created_at, true)}</p></div>) : <p className="text-sm text-slate-500">No notifications.</p>}
      </Card>
      <Card title="Customer support" testid="member-support">
        <div className="space-y-2">
          <Input placeholder="Subject" value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} data-testid="ticket-subject" />
          <Textarea placeholder="Describe your issue" value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} data-testid="ticket-message" />
          <Button className="rounded-full" disabled={f.subject.length < 3 || f.message.length < 3} onClick={create} data-testid="ticket-submit">Create ticket</Button>
        </div>
        <div className="mt-4 space-y-3">{tickets.map((t) => <Ticket key={t.id} t={t} call={call} reload={reload} />)}</div>
      </Card>
    </div>
  );
};
